module.exports = __webpack_public_path__ + "img/bg1.679e395f.png";